import { useContext, useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { DataContext } from "../../../context/DataContext";
import Select from "react-select";
import { petitions } from "../../../api/calls";
import { toast } from "sonner";
import customStyles from "../../../frontend/styles/select";
import customStylesv2 from "../../../frontend/styles/select_v2";
import {
  EditableCellNumber,
  EditableCellTextarea,
} from "../../componentsTools/EditableCell";
import Table from "../../componentsTable/TableVenta";
import { useForm } from "react-hook-form";
import productEmpty_light from "../../../frontend/assets/img/spot-illustrations/35.png";
import productEmpty_dark from "../../../frontend/assets/img/spot-illustrations/35_2.png";
import { NavLink } from "react-router-dom";
import {
  deleteIGVDefault,
  deleteProductDefault,
  addProduct,
  setValueTableDefault,
  calculateAmountsVenta,
  calculateAmountsCompra,
} from "../../../utils/helpers";

export default function EditInventory() {
  const { session, idEmpresa, user } = useContext(DataContext);
  const [obj, setObj] = useState({});
  const [type, setType] = useState("P");
  const [producto, setProducto] = useState(null);
  const [pservicio, setPservicio] = useState([]);
  const [cantidad, setCantidad] = useState("");
  const [precio, setPrecio] = useState("");
  const [clientes, setClientes] = useState([]);
  const [area, setArea] = useState([]);
  const [local, setLocal] = useState([]);
  const [almacen, setAlmacen] = useState([]);
  const [tipTraslado, setTipTraslado] = useState([]);
  const [conductor, setConductor] = useState([]);
  const [vehiculo, setVehiculo] = useState([]);
  const [igv, setIgv] = useState(true);
  const [descuento, setDescuento] = useState("");
  const [moneda, setMoneda] = useState([]);
  const [idMoneda, setIdMoneda] = useState("1");

  const [estado, setEstado] = useState(true);

  const location = useLocation();
  const id = location.state?.id;
  const tipo = location.state?.tipo;
  const main = location.state?.main;
  const navigate = useNavigate();

  const modalConfiguracion = useRef(null);
  const modalClonar = useRef(null);
  const [docType, setDocType] = useState(tipo === "E" ? "compra" : "venta");

  const [data, setData] = useState([]);

  const stadicts = (() => {
    const IGV_RATE = 0.18;

    // Calcular afecto en base imponible (sin IGV)
    const impAfecto = data.reduce(
      (acc, item) =>
        item.igv === "S" ? acc + item.importe / (1 + IGV_RATE) : acc,
      0
    );

    const impInafecto = data.reduce(
      (acc, item) => (item.igv === "N" ? acc + item.importe : acc),
      0
    );

    const dsctTasa = Number(descuento) || 0;

    // Descuento solo sobre lo afecto
    const dsctImp = impAfecto * (dsctTasa / 100);

    const baseNeta = impAfecto - dsctImp;
    const igv = baseNeta * IGV_RATE;

    return {
      subtotal: baseNeta + impInafecto, // sin IGV
      igv,
      total: baseNeta + impInafecto + igv,
      descuento: dsctImp,
    };
  })();

  const entrada = useForm({
    defaultValues: {
      tipComprobante: "GE",
      serComprobante: "0001",
      fecOperacion: new Date().toLocaleDateString("en-CA", {
        timeZone: "America/Lima",
      }),
      idMoneda: "1",
      stock: "",
      idLocal: "",
      glosa: "",
      impAfecto: 0.0,
      impInafecto: 0.0,
      _base: 0,
      igv: 18.0,
      impTotal: 0.0,
      impuesto: 0,
      dsctTasa01: 0.0,
      dsctTasa02: 0.0,
      dsctImp01: 0.0,
      dsctImp02: 0.0,
      impDsctoTotal: 0.0,
      idcont: "",
      idArea: "",
      numItems: 0,
      idUsuario: user?.idUsuario || "",
      despachado: "N",
      idAlmacen: "",
    },
  });

  const salida = useForm({
    defaultValues: {
      tipComprobante: "",
      serComprobante: "T001",
      fecOperacion: new Date().toLocaleDateString("en-CA", {
        timeZone: "America/Lima",
      }),
      idMoneda: "1",
      impAfecto: 0.0,
      impInafecto: 0.0,
      _base: 0,
      igv: 18.0,
      impTotal: 0.0,
      impuesto: 0,
      dsctTasa01: 0.0,
      dsctTasa02: 0.0,
      dsctImp01: 0.0,
      dsctImp02: 0.0,
      impDsctoTotal: 0.0,
      idcont: "",
      numItems: 0,
      idUsuario: user?.idUsuario || "",
      idVehiculo: "",
      idTranportista: "", //Vacio por defecto
      idConductor: "",
      idTipTraslado: "",
      puntPartida: "",
      puntLlegada: "",
      idAlmacen: "",
    },
  });

  const setValueTable = (row) => {
    setValueTableDefault(row, setData);
  };

  const columns = [
    {
      header: (
        <th
          className="sort white-space-nowrap align-middle"
          scope="col"
          style={{ minWidth: "200px" }}
        >
          PRODUCTO / SERVICIO
        </th>
      ),
      accessorKey: "nombreAlternativo",
      cell: ({ row }) => (
        <EditableCellTextarea
          value={row.original.nombreAlternativo}
          setValueTable={setValueTable}
          rowIndex={row.index}
          columnKey="nombreAlternativo"
        />
      ),
    },
    {
      header: (
        <th
          className="sort align-middle"
          scope="col"
          style={{ width: "150px" }}
        >
          CANTIDAD
        </th>
      ),
      accessorKey: "cantidad",
      cell: ({ row }) => (
        <EditableCellNumber
          value={row.original.cantidad}
          setValueTable={setValueTable}
          rowIndex={row.index}
          columnKey="cantidad"
          clase={""}
        />
      ),
    },
    {
      header: (
        <th
          className="sort align-middle"
          scope="col"
          style={{ width: "300px" }}
        >
          PRECIO U.
        </th>
      ),
      accessorKey: "precio",
      cell: ({ row }) => (
        <EditableCellNumber
          value={row.original.precio}
          setValueTable={setValueTable}
          rowIndex={row.index}
          columnKey="precio"
          clase={""}
        />
      ),
    },
    {
      header: (
        <th
          className="sort align-middle text-end"
          scope="col"
          style={{ width: "150px" }}
        >
          DESCUENTO
        </th>
      ),
      accessorKey: "dscto01",
      cell: ({ row }) => (
        <EditableCellNumber
          value={row.original.dscto01}
          setValueTable={setValueTable}
          rowIndex={row.index}
          columnKey="dscto01"
          clase="badge badge-phoenix fs-10 badge-phoenix-info rounded-4"
        />
      ),
    },
    {
      header: (
        <th
          className="sort align-middle text-end"
          scope="col"
          style={{ width: "150px" }}
        >
          SUB TOTAL
        </th>
      ),
      accessorKey: "subtotal",
      cell: ({ row }) => (
        <td className="color align-middle white-space-nowrap text-body py-0 text-end">
          {parseFloat(row.original.subtotal).toFixed(2)}
        </td>
      ),
    },
    {
      header: (
        <th
          className="sort align-middle text-end"
          scope="col"
          style={{ width: "250px" }}
        >
          TOTAL
        </th>
      ),
      accessorKey: "importe",
      cell: ({ row }) => (
        <td className="total align-middle fw-bold text-body-highlight text-end py-0">
          {parseFloat(row.original.importe).toFixed(2)}
        </td>
      ),
    },
    {
      header: (
        <th
          className="sort align-middle text-end"
          scope="col"
          style={{ width: "10px" }}
        ></th>
      ),
      accessorKey: "acciones",
      cell: ({ row }) => {
        const igvColor =
          row.original.igv === "S" ? "text-primary" : "text-secondary";
        return (
          <td className="total align-middle fw-bold text-body-highlight text-end py-1">
            <div className="row justify-content-end g-0">
              <div
                className="col-auto"
                onClick={() => {
                  deleteProduct(row.index);
                }}
              >
                <span
                  className="text-danger uil-trash-alt"
                  title="Eliminar"
                  style={{ fontSize: "15px", cursor: "pointer" }}
                ></span>
              </div>
              <div
                className="col-auto"
                onClick={() => {
                  deleteIGV(row.index);
                }}
              >
                <span
                  className={`${igvColor} uil-file-upload-alt`}
                  title="IGV"
                  style={{ fontSize: "15px", cursor: "pointer" }}
                ></span>
              </div>
            </div>
          </td>
        );
      },
    },
  ];

  const deleteIGV = (rowIndex) => {
    deleteIGVDefault(rowIndex, setData);
  };

  const deleteProduct = (index) => {
    deleteProductDefault(index, setData);
  };

  useEffect(() => {
    const fetchData = async () => {
      setEstado(tipo === "E" ? true : false);
      setData([]);
      const typeState = tipo === "E" ? true : false;

      const response = typeState
        ? await petitions.getEntrada(idEmpresa(), session().token, id)
        : await petitions.getSalida(idEmpresa(), session().token, id);

      if (response.status === "success") {
        setObj(response.data);
        setDescuento(
          typeState
            ? response.data.entrada?.dscto01 ?? 0
            : response.data.salida?.dscto01 ?? 0
        );
        setIdMoneda(
          typeState
            ? response.data.entrada?.idMoneda ?? "1"
            : response.data.salida?.idMoneda ?? "1"
        );

        response?.data?.detalle.forEach((item) => {
          setData((prevData) => [
            ...prevData,
            {
              idPServicio: item.idPServicio,
              cantidad: item.cantidad,
              precio: item.precio,
              igv: item.igv,
              dscto01: item.dscto01,
              dscto02: item.dscto02,
              subtotal: item.cantidad * item.precio,
              dsctoImporte: item.dsctoImporte,
              importe: item.importe,
              idUsuario: user?.idUsuario || "",
              nombreAlternativo: item.name,
            },
          ]);
        });

        if (typeState) {
          entrada.setValue(
            "tipComprobante",
            response.data.entrada.tipComprobante,
            {
              shouldValidate: true,
            }
          );
          entrada.setValue(
            "serComprobante",
            response.data.entrada.serComprobante,
            {
              shouldValidate: true,
            }
          );
          entrada.setValue("idMoneda", response.data.entrada.idMoneda, {
            shouldValidate: true,
          });
          entrada.setValue("glosa", response.data.entrada.glosa ?? "", {
            shouldValidate: true,
          });
          entrada.setValue("idcont", response.data.entrada.idcont ?? "", {
            shouldValidate: true,
          });
          entrada.setValue("idLocal", response.data.entrada.idlocal ?? "", {
            shouldValidate: true,
          });
          entrada.setValue("idArea", response.data.entrada.idArea ?? "", {
            shouldValidate: true,
          });
          entrada.setValue("idAlmacen", response.data.entrada.idAlmacen ?? "", {
            shouldValidate: true,
          });
        } else {
          salida.setValue("idcont", response.data.salida.idcont ?? "", {
            shouldValidate: true,
          });
          salida.setValue(
            "idTipTraslado",
            response.data.salida.idTipTraslado ?? "",
            {
              shouldValidate: true,
            }
          );
          salida.setValue(
            "puntLlegada",
            response.data.salida.puntLlegada ?? "",
            {
              shouldValidate: true,
            }
          );
          salida.setValue(
            "puntPartida",
            response.data.salida.puntPartida ?? "",
            {
              shouldValidate: true,
            }
          );
          salida.setValue("idVehiculo", response.data.salida.idVehiculo ?? "", {
            shouldValidate: true,
          });
          salida.setValue(
            "idConductor",
            response.data.salida.idConductor ?? "",
            {
              shouldValidate: true,
            }
          );
        }
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchData();
  }, [id, idEmpresa, session, user?.idUsuario, tipo, entrada, salida]);

  useEffect(() => {
    const fetchMoneda = async () => {
      const response = await petitions.getMoneda(idEmpresa(), session().token);
      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.idMoneda.toString(),
          label: e.simbolo,
        }));
        setMoneda(array);
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchMoneda();
  }, [session, idEmpresa, entrada, salida]);

  useEffect(() => {
    const fetchTipTraslado = async () => {
      const obj = session();
      const response = await petitions.getTipTraslado(idEmpresa(), obj.token);
      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.id,
          label: e.descripcion,
        }));
        setTipTraslado(array);
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchTipTraslado();
  }, [idEmpresa, session]);

  useEffect(() => {
    const fetchConductores = async () => {
      const obj = session();
      const response = await petitions.getConductor(idEmpresa(), obj.token);
      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.idConductor,
          label: e.nombre + " " + e.paterno + " " + e.materno,
        }));
        setConductor(array);
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchConductores();
  }, [idEmpresa, session]);


  useEffect(() => {
    const fetchVehiculos = async () => {
      const obj = session();
      const response = await petitions.getVehiculos(idEmpresa(), obj.token);
      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.placa,
          label: e.placa,
        }));
        setVehiculo(array);
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchVehiculos();
  }, [estado, idEmpresa, session]);


  useEffect(() => {
    const fetchAreas = async () => {
      const obj = session();
      const response = await petitions.getAreas(idEmpresa(), obj.token);
      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.idArea,
          label: e.nomArea,
        }));
        setArea(array);
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchAreas();
  }, [session, idEmpresa]);


  useEffect(() => {
    const fetchLocal = async () => {
      const obj = session();
      const response = await petitions.getLocal(idEmpresa(), obj.token);
      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.idLocal,
          label: e.nomLocal,
        }));
        setLocal(array);
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchLocal();
  }, [session, idEmpresa]);

  useEffect(() => {
    const fetchAlmacen = async () => {
      const response = await petitions.getAlmacen(idEmpresa(), session().token);
      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.idAlmacen,
          label: e.nombre,
        }));
        setAlmacen(array);
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchAlmacen();
  }, [idEmpresa, session]);


  useEffect(() => {
    const fetchClientes = async () => {
      const obj = session();
      const response = await petitions.getClientesSelect(idEmpresa(), obj.token);
      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.id,
          label: e.descripcion,
        }));
        setClientes(array);
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchClientes();
  }, [idEmpresa, session]);

  useEffect(() => {
    const axiosProducts = async () => {
      setData([]);
      const response = await petitions.getProductsType(
        idEmpresa(),
        session().token,
        type
      );
      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.idProducto,
          label: e.nombre,
          pventa: e.pVenta,
        }));
        setPservicio(array);
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    axiosProducts();
  }, [idEmpresa, session, type]);

  const sendInventario = estado
    ? entrada.handleSubmit(async (form) => {
        const maestro = calculateAmountsCompra(form, data, descuento);
        maestro.idMoneda = idMoneda;
        maestro.idCompras = obj?.entrada?.idCompra || "";

        var join = {
          entrada: maestro,
          detalle: data,
        };

        toast("¿Estas seguro(a) de actualizar esta entrada?", {
          action: {
            label: "Confirmar",
            onClick: async () => {
              const response = await petitions.updateEntrada(
                idEmpresa(),
                session().token,
                join
              );
              if (response.status === "success") {
                toast.success(
                  "Entrada " +
                    obj?.entrada?.tipComprobante +
                    "-" +
                    obj?.entrada?.serComprobante +
                    "-" +
                    obj?.entrada?.nroComprobante +
                    " actualizada correctamente"
                );
                entrada.reset();
                setData([]);
                setIdMoneda("1");
                navigate("/main/VerES", { replace: true });
              } else {
                var msg =
                  typeof response.code === "string"
                    ? response.message
                    : response.data;
                toast.error(msg);
              }
            },
          },
        });
      })
    : salida.handleSubmit(async (form) => {
        const maestro = calculateAmountsVenta(form, data, descuento);
        maestro.idMoneda = idMoneda;
        maestro.idVenta = obj?.salida?.idVenta || "";

        const join = {
          salida: maestro,
          detalle: data,
        };

        toast("¿Estas seguro(a) de actualizar esta salida?", {
          action: {
            label: "Confirmar",
            onClick: async () => {
              const response = await petitions.updateSalida(
                idEmpresa(),
                session().token,
                join
              );
              if (response.status === "success") {
                toast.success(
                  "Salida " +
                    obj?.salida?.tipComprobante +
                    "-" +
                    obj?.salida?.serComprobante +
                    "-" +
                    obj?.salida?.nroComprobante +
                    " actualizada correctamente"
                );
                setIdMoneda("1");
                salida.reset();
                setData([]);
                navigate("/main/VerES", { replace: true });
              } else {
                const msg =
                  typeof response.code === "string"
                    ? response.message
                    : response.data;
                toast.error(msg);
              }
            },
          },
        });
      });

  const clone = async () => {
    obj.status = true; //PARA INDICAR QUE ES UN COMPROBANTE CLONADO
    const modalInstance = window.bootstrap.Modal.getInstance(
      modalClonar.current
    );
    modalInstance.hide();

    const { ...rest } = estado ? obj.entrada : obj.salida;
    estado ? (obj.compra = { ...rest }) : (obj.venta = { ...rest });

    estado ? delete obj.entrada : delete obj.salida;

    let url = "";
    switch (docType) {
      case "venta":
        obj.venta.dsctoTasa01 = obj.venta.dscto01;
        delete obj.venta.dscto01;
        obj.venta.tipComprobante = "01";
        url = "EmitirComprobantes";
        break;
      case "cotizacion":
        obj.venta.dsctoTasa01 = obj.venta.dscto01;
        delete obj.venta.dscto01;
        url = "EmitirCotizacion";
        break;
      case "guiaremision":
        obj.venta.dsctoTasa01 = obj.venta.dscto01;
        delete obj.venta.dscto01;
        url = "NuevaES";
        obj.type = "S";
        break;
      case "compra":
        obj.compra.dsctoTasa01 = obj.compra.dscto01;
        delete obj.compra.dscto01;
        url = "EmitirOC";
        break;
      case "entrada":
        obj.compra.dsctoTasa01 = obj.compra.dscto01;
        delete obj.compra.dscto01;
        obj.type = "E";
        url = "NuevaES";
        break;
    }

    obj.detalle = obj.detalle.map((item) => ({
      ...item,
      idPServicio: item.idPServicio ?? "",
      cantidad: item.cantidad ?? 0,
      precio: item.precio ?? 0,
      igv: item.igv ?? "N",
      dscto01: item.dscto01 ?? 0,
      dscto02: item.dscto02 ?? 0,
      subtotal: (item.cantidad * item.precio).toFixed(2),
      dsctoImporte: item.dsctoImporte ?? 0,
      importe: item.importe ?? 0,
      idUsuario: session().idUsuario,
      nombreAlternativo: item.name || "",
    }));

    navigate("/main/" + url, {
      replace: true,
      state: { body: obj },
    });
  };

  return (
    <>
      <div className="row justify-content-between align-items-end g-3 mb-4">
        <div className="col-12 col-sm-auto col-xl-8">
          <div className="d-flex align-items-center gap-3 flex-wrap">
            <button
              className="px-2 py-1 pt-2 bg-primary-subtle rounded-3 border-0"
              type="button"
              onClick={() => {
                navigate(main, { replace: true });
              }}
            >
              <span className="fas fa-long-arrow-alt-left"></span>
            </button>
            <h2 className="mb-0">
              Editar {tipo === "E" ? "entrada" : "salida"}
            </h2>
            <h3 className="text-primary mt-2">
              <span className="bg-body pe-2">
                {estado
                  ? obj?.entrada
                    ? `${obj.entrada.tipComprobante || ""}-${
                        obj.entrada.serComprobante || ""
                      }-${obj.entrada.nroComprobante || ""}`
                    : ""
                  : obj?.salida
                  ? `${obj.salida.tipComprobante || ""}-${
                      obj.salida.serComprobante || ""
                    }-${obj.salida.nroComprobante || ""}`
                  : ""}
              </span>
            </h3>
          </div>
        </div>
        <div className="col-12 col-sm-auto col-xl-4">
          <div className="d-flex">
            <select
              className="form-control form-control-sm me-2 rounded-4 border-0 shadow-sm"
              value={idMoneda}
              onChange={(event) => {
                setIdMoneda(event.target.value);
              }}
            >
              {moneda.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            <button
              className="btn px-3 btn-phoenix-secondary px-3 me-2 rounded-4"
              type="button"
              data-bs-toggle="modal"
              data-bs-target="#filterModal"
              data-boundary="window"
              aria-haspopup="true"
              aria-expanded="false"
              data-bs-reference="parent"
              onClick={() => {
                const modal = new window.bootstrap.Modal(
                  modalConfiguracion.current
                );
                modal.show();
              }}
            >
              <span
                className="fas fa-cog text-primary"
                data-fa-transform="down-3"
              ></span>
            </button>
            <button
              className="btn px-3 btn-phoenix-primary px-3 me-1 rounded-4"
              type="button"
              title="Clonar"
              onClick={() => {
                if (obj?.entrada?.stock === "N" || obj?.salida?.stock === "N") {
                  toast.warning("No puedes clonar un comprobante clonado.");
                  return;
                }
                const modal = new window.bootstrap.Modal(modalClonar.current);
                modal.show();
              }}
            >
              <span className="far fa-clone" data-fa-transform="down-3"></span>
            </button>
            <button
              className="btn px-3 btn-phoenix-secondary px-3 me-1 rounded-4"
              onClick={() => {
                estado ? entrada.reset() : salida.reset();
                setData([]);
                setDescuento("");
              }}
            >
              <span className="fas fa-undo" data-fa-transform="down-3"></span>
            </button>
            <form onSubmit={sendInventario}>
              <button
                className="btn btn-primary px-5 w-100 text-nowrap rounded-4"
                href="event-detail.html"
                disabled={data.length === 0}
              >
                Actualizar
              </button>
            </form>
          </div>
        </div>
      </div>

      <div className="row g-5">
        <div className="col-xl-8">
          <div className="row gx-3 gy-4 mb-4">
            <div className="row g-2">
              <div className="col-md-2">
                <div className="d-flex">
                  <button
                    type="button"
                    className={`btn btn-phoenix-info btn-icon btn-icon-lg me-1 rounded-3 ${
                      type === "P" ? "active" : ""
                    }`}
                    title="Producto"
                    onClick={() => {
                      setProducto(null);
                      setType("P");
                    }}
                  >
                    {" "}
                    <span className="fas fa-book"></span>{" "}
                  </button>
                  <button
                    type="button"
                    className={`btn btn-phoenix-info btn-icon btn-icon-lg me-1 rounded-3 ${
                      type === "S" ? "active" : ""
                    }`}
                    title="Servicio"
                    onClick={() => {
                      setProducto(null);
                      setType("S");
                    }}
                  >
                    {" "}
                    <span className="fas fa-wrench"></span>{" "}
                  </button>
                  <button
                    type="button"
                    className={`btn btn-phoenix-info btn-icon btn-icon-lg rounded-3 ${
                      type === "Q" ? "active" : ""
                    }`}
                    title="Paquete"
                    onClick={() => {
                      setProducto(null);
                      setType("Q");
                    }}
                  >
                    <span className="fas fa-box-open"></span>{" "}
                  </button>
                </div>
              </div>
              <div className="col-md-5">
                <Select
                  className="mb-0 mi-select"
                  classNamePrefix="rs"
                  options={pservicio}
                  value={producto}
                  styles={customStylesv2}
                  placeholder={
                    type === "P"
                      ? "Buscar Producto"
                      : type === "S"
                      ? "Buscar Servicio"
                      : type === "Q"
                      ? "Buscar Paquete"
                      : "Buscar..."
                  }
                  isLoading={false}
                  isClearable={true}
                  onChange={(event) => {
                    if (!event) {
                      setProducto(null);
                      setCantidad(0);
                      setPrecio(0);
                    } else {
                      setProducto(event);
                      setCantidad(1);
                      setPrecio(event.pventa);
                    }
                  }}
                />
              </div>
              <div className="col-md-2">
                <input
                  className="form-control input-spin-none rounded-4 border-0 shadow-sm"
                  type="number"
                  name="add-property-wizard-email"
                  id="add-property-wizardwizard-email"
                  placeholder="Cantidad"
                  value={cantidad}
                  onChange={(event) => {
                    setCantidad(event.target.value);
                  }}
                />
              </div>
              <div className="col-md-2">
                <input
                  className="form-control input-spin-none rounded-4 border-0 shadow-sm"
                  type="number"
                  name="add-property-wizard-phone"
                  id="add-property-wizardwizard-phone"
                  placeholder="Precio"
                  value={precio}
                  onChange={(event) => {
                    setPrecio(event.target.value);
                  }}
                />
              </div>
              <div className="col-md-1">
                <button
                  className="btn btn-phoenix-secondary px-3 me-2 rounded-4"
                  type="button"
                  data-boundary="window"
                  aria-haspopup="true"
                  aria-expanded="false"
                  data-bs-reference="parent"
                  disabled={!producto || Object.keys(producto).length === 0}
                  onClick={() => {
                    addProduct(
                      producto,
                      cantidad,
                      precio,
                      igv,
                      setData,
                      setProducto,
                      setCantidad,
                      setPrecio,
                      user?.idUsuario
                    );
                  }}
                >
                  <span
                    className="fas fa-plus text-success"
                    data-fa-transform="down-2"
                  ></span>
                </button>
              </div>
            </div>
          </div>
          <div className="row g-5 gy-7">
            <div className="col-12 col-xl-12 col-xxl-12">
              <div
                id="orderTable"
                data-list='{"valueNames":["products","color","size","price","quantity","total"],"page":10}'
                className="mb-3"
              >
                <div className="table-responsive scrollbar">
                  <Table data={data} columns={columns} />
                </div>
              </div>
              {data.length > 0 ? (
                <>
                  <div className="d-flex justify-content-end py-1 border-translucent">
                    <span className="badge badge-phoenix fs-10 badge-phoenix-secondary mt-1 mb-2 me-4 rounded-3 border-0 shadow-sm">
                      <span className="far fa-lightbulb me-1"></span> El
                      descuento afecta solo a operaciones gravadas
                    </span>
                    <p className="text-body-emphasis  lh-sm mb-0 me-5 mt-1">
                      Descuentos (%)
                    </p>
                    <p className="text-body-emphasis fw-bold lh-sm mb-0 me-2 mt-1">
                      {moneda.find((mon) => mon.value === idMoneda)?.label}
                    </p>
                    <input
                      type="number"
                      placeholder="Descuento"
                      className="form-control form-control-sm text-star rounded-4 border-0 shadow-sm"
                      style={{ minWidth: "130px", maxWidth: "120px" }}
                      value={
                        !data.some((item) => item.igv === "S") ? 0 : descuento
                      }
                      onChange={(e) => setDescuento(e.target.value)}
                      disabled={!data.some((item) => item.igv === "S")}
                    />
                  </div>
                  <div className="d-flex justify-content-end py-1 border-translucent">
                    <p className="text-body-emphasis  lh-sm mb-0 me-5">
                      Subtotal
                    </p>
                    <p className="text-body-emphasis fw-bold lh-sm mb-0 me-2">
                      {moneda.find((mon) => mon.value === idMoneda)?.label}
                    </p>
                    <p
                      className="text-body-emphasis fw-semibold lh-sm mb-0 me-2"
                      style={{ minWidth: "120px" }}
                    >
                      {parseFloat(stadicts.subtotal).toFixed(2)}
                    </p>
                  </div>
                  <div className="d-flex justify-content-end py-1 border-translucent">
                    <p className="text-body-emphasis  lh-sm mb-0 me-5">IGV</p>
                    <p className="text-body-emphasis fw-bold lh-sm mb-0 me-2">
                      {moneda.find((mon) => mon.value === idMoneda)?.label}
                    </p>
                    <p
                      className="text-body-emphasis fw-semibold lh-sm mb-0 me-2"
                      style={{ minWidth: "120px" }}
                    >
                      {parseFloat(stadicts.igv).toFixed(2)}
                    </p>
                  </div>
                  <div className="d-flex justify-content-end py-1 border-translucent">
                    <p className="text-body-emphasis fw-semibold lh-sm mb-0 me-5">
                      Total
                    </p>
                    <p className="text-body-emphasis fw-bold lh-sm mb-0 me-2">
                      {moneda.find((mon) => mon.value === idMoneda)?.label}
                    </p>
                    <p
                      className="text-body-emphasis fw-bold lh-sm mb-0 me-2"
                      style={{ minWidth: "120px" }}
                    >
                      {parseFloat(stadicts.total).toFixed(2)}
                    </p>
                  </div>
                </>
              ) : (
                <div
                  className="d-flex flex-column align-items-center justify-content-center"
                  style={{ height: "300px" }}
                >
                  <img
                    className="d-dark-none mt-5 position-sticky"
                    src={productEmpty_light}
                
                    alt="No hay productos"
                    style={{
                      maxWidth: "300px",
                      marginBottom: "10px",
                      opacity: "0.5",
                    }}
                  />
                  <img
                    className="d-light-none mt-5 position-sticky"
                    src={productEmpty_dark}
                    alt="No hay productos"
                    style={{
                      maxWidth: "300px",
                      marginBottom: "10px",
                      opacity: "0.5",
                    }}
                  />

                  <h5 className="text-muted mt-3" style={{opacity: "0.5"}}>No hay productos</h5>            
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="col-xl-4">
          <div className="border-translucent pb-6 mb-1">
            <div className="card mb-3 rounded-4 border-0 shadow-sm">
              <div className="card-body">
                <div className="row gx-3">
                  <div className="col-12 col-sm-6 col-xl-12">
                    {estado ? (
                      <div>
                        <div className="col-12 col-sm-6 col-xl-12">
                          <div className="mb-3">
                            <label
                              className="form-label"
                              htmlFor="add-property-wizard-phone"
                            >
                              Observaciones
                            </label>
                            <textarea
                              className="form-control rounded-4"
                              id="exampleTextarea"
                              placeholder="Escribe la observación de tu entrada aquí..."
                              rows="3"
                              {...entrada.register("glosa", {
                                maxLength: {
                                  value: 500,
                                  message: "Descripción demasiada larga",
                                },
                              })}
                              defaultValue=""
                            />
                            {entrada.formState.errors?.obs && (
                              <code>
                                {entrada.formState.errors.obs.message}
                              </code>
                            )}
                          </div>
                        </div>
                        <hr />
                        <div className="col-12 col-sm-6 col-xl-12">
                          <div className="mb-2">
                            <div className="d-flex flex-wrap mb-2">
                              <h5 className="mb-0 text-body-highlight me-2">
                                Proveedor
                              </h5>
                              <NavLink
                                className="fw-bold fs-9"
                                to={"/main/NuevoCliente"}
                              >
                                Nuevo proveedor
                              </NavLink>
                            </div>
                            <Select
                              className="mb-0 mi-select mi-select-bordered"
                              classNamePrefix="rs"
                              styles={customStyles}
                              placeholder="Selecciona un proveedor"
                              options={clientes}
                              value={
                                clientes.find(
                                  (option) =>
                                    option.value === entrada.watch("idcont")
                                ) || null
                              }
                              {...entrada.register("idcont", {
                                required: {
                                  value: true,
                                  message: "Este campo es obligatorio",
                                },
                              })}
                              onChange={(event) => {
                                entrada.setValue("idcont", event.value);
                              }}
                            />
                            {entrada.formState.errors?.idcont && (
                              <code>
                                {entrada.formState.errors.idcont.message}
                              </code>
                            )}
                          </div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-lg-6">
                            <div className="mb-2">
                              <label
                                className="form-label me-2"
                                htmlFor="add-property-wizard-phone"
                              >
                                Área
                              </label>
                              <NavLink
                                className="fw-bold fs-10"
                                to={"/main/AreaLocal"}
                              >
                                Nuevo
                              </NavLink>
                              <Select
                                className="mb-0 mi-select mi-select-bordered"
                                classNamePrefix="rs"
                                styles={customStyles}
                                placeholder="Selecciona un área"
                                options={area}
                                value={
                                  area.find(
                                    (option) =>
                                      option.value === entrada.watch("idArea")
                                  ) || null
                                }
                                {...entrada.register("idArea", {
                                  required: {
                                    value: true,
                                    message: "Este campo es obligatorio",
                                  },
                                })}
                                onChange={(event) => {
                                  entrada.setValue("idArea", event.value);
                                }}
                              />
                              {entrada.formState.errors?.idArea && (
                                <code>
                                  {entrada.formState.errors.idArea.message}
                                </code>
                              )}
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="mb-2">
                              <label
                                className="form-label me-2"
                                htmlFor="add-property-wizard-phone"
                              >
                                Local
                              </label>
                              <NavLink
                                className="fw-bold fs-10"
                                to={"/main/AreaLocal"}
                              >
                                Nuevo
                              </NavLink>
                              <Select
                                className="mb-0 mi-select mi-select-bordered"
                                classNamePrefix="rs"
                                styles={customStyles}
                                placeholder="Selecciona un local"
                                options={local}
                                value={
                                  local.find(
                                    (option) =>
                                      option.value === entrada.watch("idLocal")
                                  ) || null
                                }
                                {...entrada.register("idLocal", {
                                  required: {
                                    value: true,
                                    message: "Este campo es obligatorio",
                                  },
                                })}
                                onChange={(event) => {
                                  entrada.setValue("idLocal", event.value);
                                }}
                              />
                              {entrada.formState.errors?.idLocal && (
                                <code>
                                  {entrada.formState.errors.idLocal.message}
                                </code>
                              )}
                            </div>
                          </div>
                          <div className="col-lg-12 mb-1">
                            <div className="mb-2">
                              <label
                                className="form-label me-2"
                                htmlFor="add-property-wizard-phone"
                              >
                                Almacén
                              </label>
                              <NavLink
                                className="fw-bold fs-10"
                                to={"/main/Almacen"}
                              >
                                Nuevo almacén
                              </NavLink>
                              <Select
                                className="mb-0 mi-select mi-select-bordered"
                                classNamePrefix="rs"
                                styles={customStyles}
                                placeholder="Selecciona un almacén"
                                options={almacen}
                                value={
                                  almacen.find(
                                    (option) =>
                                      option.value ===
                                      entrada.watch("idAlmacen")
                                  ) || null
                                }
                                {...entrada.register("idAlmacen", {
                                  required: {
                                    value: true,
                                    message: "Este campo es obligatorio",
                                  },
                                })}
                                onChange={(event) => {
                                  entrada.setValue("idAlmacen", event.value);
                                }}
                              />
                              {entrada.formState.errors?.idAlmacen && (
                                <code>
                                  {entrada.formState.errors.idAlmacen.message}
                                </code>
                              )}
                            </div>
                          </div>
                          <div className="d-flex justify-content-between border-top border-translucent border-dashed pt-4">
                            <h4 className="mb-0">Total :</h4>
                            <h4 className="mb-0">
                              {
                                moneda.find((mon) => mon.value === idMoneda)
                                  ?.label
                              }{" "}
                              {" " + parseFloat(stadicts.total).toFixed(2)}
                            </h4>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <div>
                        {obj?.salida?.tipComprobante !== "" &&
                          obj?.salida?.tipComprobante !== "GE" && (
                            <div className="d-flex justify-content-center align-items-center mb-3">
                              <p className="fs-8 text-body-tertiary fw-bold mb-0 d-flex align-items-center">
                                <span className="fa-solid far fa-file-alt text-body-secondary me-2"></span>
                                {obj?.salida?.tipComprobante === "09"
                                  ? "Guía de remisión remitente"
                                  : obj?.salida?.tipComprobante === "31"
                                  ? "Guía de remisión transportista"
                                  : "Guía de remisión"}
                              </p>
                            </div>
                          )}
                        <div className="row mb-2">
                          <div className="col-lg-12 mb-2">
                            <div className="d-flex flex-wrap mb-2">
                              <h5 className="mb-0 text-body-highlight me-2">
                                Cliente
                              </h5>
                              <NavLink
                                className="fw-bold fs-9"
                                to={"/main/NuevoCliente"}
                              >
                                Nuevo cliente
                              </NavLink>
                            </div>
                            <Select
                              className="mb-0 mi-select mi-select-bordered"
                              classNamePrefix="rs"
                              styles={customStyles}
                              placeholder="Selecciona un cliente"
                              options={clientes}
                              value={
                                clientes.find(
                                  (option) =>
                                    option.value === salida.watch("idcont")
                                ) || null
                              }
                              {...salida.register("idcont", {
                                required: {
                                  value: true,
                                  message: "Este campo es obligatorio",
                                },
                              })}
                              onChange={(event) => {
                                salida.setValue("idcont", event.value);
                              }}
                            />
                            {salida.formState.errors?.idcont && (
                              <code>
                                {salida.formState.errors.idcont.message}
                              </code>
                            )}
                          </div>
                          <div className="col-lg-12 mb-1">
                            <div className="mb-1">
                              <label
                                className="form-label"
                                htmlFor="add-property-wizard-phone"
                              >
                                Motivo de traslado
                              </label>
                              <Select
                                className="mb-0 mi-select mi-select-bordered"
                                classNamePrefix="rs"
                                styles={customStyles}
                                placeholder="Selecciona un motivo de traslado"
                                options={tipTraslado}
                                value={
                                  tipTraslado.find(
                                    (option) =>
                                      option.value ===
                                      salida.watch("idTipTraslado")
                                  ) || null
                                }
                                {...salida.register("idTipTraslado", {
                                  required: {
                                    value: true,
                                    message: "Este campo es obligatorio",
                                  },
                                })}
                                onChange={(event) => {
                                  salida.setValue("idTipTraslado", event.value);
                                }}
                              />
                              {salida.formState.errors?.idTipTraslado && (
                                <code>
                                  {
                                    salida.formState.errors.idTipTraslado
                                      .message
                                  }
                                </code>
                              )}
                            </div>
                          </div>
                          <div className="col-lg-12 mb-1">
                            <div className="mb-1">
                              <label
                                className="form-label"
                                htmlFor="add-property-wizard-phone"
                              >
                                Punto de llegada
                              </label>
                              <input
                                className="form-control input-spin-none rounded-4"
                                id="exampleFormControlInput"
                                type="text"
                                {...salida.register("puntPartida", {
                                  required: {
                                    value: true,
                                    message: "Este campo es obligatorio",
                                  },
                                })}
                              />
                              {salida.formState.errors?.puntPartida && (
                                <code>
                                  {salida.formState.errors.puntPartida.message}
                                </code>
                              )}
                            </div>
                          </div>
                          <div className="col-lg-12 mb-1">
                            <div className="mb-1">
                              <label
                                className="form-label"
                                htmlFor="add-property-wizard-phone"
                              >
                                Punto de partida
                              </label>
                              <input
                                className="form-control input-spin-none rounded-4"
                                id="exampleFormControlInput"
                                type="text"
                                {...salida.register("puntLlegada", {
                                  required: {
                                    value: true,
                                    message: "Este campo es obligatorio",
                                  },
                                })}
                              />
                              {salida.formState.errors?.puntLlegada && (
                                <code>
                                  {salida.formState.errors.puntLlegada.message}
                                </code>
                              )}
                            </div>
                          </div>
                          <hr />
                          <div className="col-lg-12 mb-1">
                            <div className="d-flex flex-wrap mb-1">
                              <h5 className="mb-0 text-body-highlight me-2">
                                Datos de transporte
                              </h5>
                            </div>
                          </div>
                          <div className="col-lg-12 mb-1">
                            <div className="mb-1">
                              <label
                                className="form-label me-2"
                                htmlFor="add-property-wizard-phone"
                              >
                                Vehículo
                              </label>
                              <NavLink
                                className="fw-bold fs-10"
                                to={"/main/Vehiculo"}
                              >
                                Nuevo vehículo
                              </NavLink>
                              <Select
                                className="mb-0 mi-select mi-select-bordered"
                                classNamePrefix="rs"
                                styles={customStyles}
                                placeholder="Selecciona un vehículo"
                                options={vehiculo}
                                value={
                                  vehiculo.find(
                                    (option) =>
                                      option.value ===
                                      salida.watch("idVehiculo")
                                  ) || null
                                }
                                {...salida.register("idVehiculo", {
                                  required: {
                                    value: true,
                                    message: "Este campo es obligatorio",
                                  },
                                })}
                                onChange={(event) => {
                                  salida.setValue("idVehiculo", event.value);
                                }}
                              />
                              {salida.formState.errors?.idVehiculo && (
                                <code>
                                  {salida.formState.errors.idVehiculo.message}
                                </code>
                              )}
                            </div>
                          </div>
                          <div className="col-lg-12 mb-1">
                            <div className="mb-1">
                              <label
                                className="form-label me-2"
                                htmlFor="add-property-wizard-phone"
                              >
                                Conductor
                              </label>
                              <NavLink
                                className="fw-bold fs-10"
                                to={"/main/Vehiculo"}
                              >
                                Nuevo conductor
                              </NavLink>
                              <Select
                                className="mb-0 mi-select mi-select-bordered"
                                classNamePrefix="rs"
                                styles={customStyles}
                                placeholder="Selecciona un conductor"
                                options={conductor}
                                value={
                                  conductor.find(
                                    (option) =>
                                      option.value ===
                                      salida.watch("idConductor")
                                  ) || null
                                }
                                {...salida.register("idConductor", {
                                  required: {
                                    value: true,
                                    message: "Este campo es obligatorio",
                                  },
                                })}
                                onChange={(event) => {
                                  salida.setValue("idConductor", event.value);
                                }}
                              />
                              {salida.formState.errors?.idConductor && (
                                <code>
                                  {salida.formState.errors.idConductor.message}
                                </code>
                              )}
                            </div>
                          </div>
                          <div className="d-flex justify-content-between border-top border-translucent border-dashed pt-4">
                            <h4 className="mb-0">Total :</h4>
                            <h4 className="mb-0">
                              {
                                moneda.find((mon) => mon.value === idMoneda)
                                  ?.label
                              }{" "}
                              {" " + parseFloat(stadicts.total).toFixed(2)}
                            </h4>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="staticBackdrop"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="false"
        ref={modalConfiguracion}
      >
        <div className="modal-dialog">
          <div className="modal-content rounded-4">
            <div className="modal-header border-0">
              <h3 className="modal-title " id="documentModalLabel">
                Configuración de inventario
              </h3>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <h5 className="mb-3">Opciones generales</h5>

              <div className="p-3 border rounded-4">
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    id="flexSwitchCheckChecked"
                    type="checkbox"
                    checked={igv}
                    onChange={() => {
                      setIgv(!igv);
                    }}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="flexSwitchCheckChecked"
                  >
                    Impuesto General a las Ventas (IGV)
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="documentModal"
        tabIndex="-1"
        aria-labelledby="documentModalLabel"
        aria-hidden="true"
        ref={modalClonar}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content rounded-5 p-3">
            {/* Header */}
            <div className="modal-header border-0">
              <h3 className="modal-title " id="documentModalLabel">
                Elija documento destino
              </h3>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            {/* Body */}
            <div className="modal-body">
              <div className="list-group rounded-3">
                {estado ? (
                  <>
                    <label className="list-group-item d-flex align-items-center justify-content-between">
                      <div className="d-flex align-items-center text-primary fw-bold">
                        <span className="far fa-file-alt text-secondary fs-4 me-4"></span>
                        Compra
                      </div>
                      <input
                        className="form-check-input"
                        type="radio"
                        name="docType"
                        value="compra"
                        checked={docType === "compra"}
                        onChange={(event) => {
                          setDocType(event.target.value);
                        }}
                      />
                    </label>

                    <label className="list-group-item d-flex align-items-center justify-content-between">
                      <div className="d-flex align-items-center text-primary fw-bold">
                        <span className="far fa-file-archive text-secondary fs-4 me-4"></span>
                        Entrada
                      </div>
                      <input
                        className="form-check-input"
                        type="radio"
                        name="docType"
                        value="entrada"
                        checked={docType === "entrada"}
                        onChange={(event) => {
                          setDocType(event.target.value);
                        }}
                      />
                    </label>
                  </>
                ) : (
                  <>
                    <label className="list-group-item d-flex align-items-center justify-content-between">
                      <div className="d-flex align-items-center text-primary fw-bold">
                        <span className="far fa-file-alt text-secondary fs-4 me-4"></span>
                        Venta
                      </div>
                      <input
                        className="form-check-input"
                        type="radio"
                        name="docType"
                        value="venta"
                        checked={docType === "venta"}
                        onChange={(event) => {
                          setDocType(event.target.value);
                        }}
                      />
                    </label>

                    <label className="list-group-item d-flex align-items-center justify-content-between">
                      <div className="d-flex align-items-center text-primary fw-bold">
                        <span className="far fa-file-archive text-secondary fs-4 me-4"></span>
                        Cotización
                      </div>
                      <input
                        className="form-check-input"
                        type="radio"
                        name="docType"
                        value="cotizacion"
                        checked={docType === "cotizacion"}
                        onChange={(event) => {
                          setDocType(event.target.value);
                        }}
                      />
                    </label>

                    <label className="list-group-item d-flex align-items-center justify-content-between">
                      <div className="d-flex align-items-center text-primary fw-bold">
                        <span className="fas fa-caravan text-secondary fs-4 me-2"></span>
                        Guía de Remisión
                      </div>
                      <input
                        className="form-check-input"
                        type="radio"
                        name="docType"
                        value="guiaremision"
                        checked={docType === "guiaremision"}
                        onChange={(event) => {
                          setDocType(event.target.value);
                        }}
                      />
                    </label>
                  </>
                )}
              </div>
            </div>

            {/* Footer */}
            <div className="modal-footer border-0">
              <button
                type="button"
                className="btn btn-subtle-secondary rounded-4"
                data-bs-dismiss="modal"
              >
                Cancelar
              </button>
              <button
                type="button"
                className="btn btn-subtle-primary rounded-4"
                onClick={() => {
                  clone();
                }}
              >
                Clonar
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
